import React from "react"
import { useTranslation } from "react-i18next"
import { useFormikContext } from "formik"
import { useSelector } from "react-redux"
import { stringFormatting } from "../../../../../helpers/TextHelper.js"
import { BaseMapSelector } from "../../../../../../component/atoms/MapSelector/BaseMapSelector.jsx"

export const PreviewBase = () => {
  const { t } = useTranslation()
  const { values } = useFormikContext()
  const { MasterData } = useSelector((state) => state)

  return (
    <div className={"p-8"}>
      <h5 className={"mt-4 font-weight-bolder"}>{t("label_detail_base")}</h5>
      <div className={"d-flex mt-8 border-bottom py-4"}>
        <div className={"flex-1"}>
          <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
            <span className={"text-neutral-gray"}>{t("label_regional")}</span>
            <span className={"font-size-lg"}>{stringFormatting(MasterData?.listRegionalAll?.find((regional) => regional?.id === values?.regionalId)?.name)}</span>
          </div>
          <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
            <span className={"text-neutral-gray"}>{t("label_sub_regional")}</span>
            <span className={"font-size-lg"}>{stringFormatting(MasterData?.listSubRegionalByRole?.find((subRegional) => subRegional?.id === values?.sub_regional_id)?.name)}</span>
          </div>
        </div>
        <div className={"flex-1"}>
          <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
            <span className={"text-neutral-gray"}>{t("label_base_type")}</span>
            <span className={"font-size-lg"}>{stringFormatting(MasterData?.listBaseType?.find((baseType) => baseType?.type_enum === values?.type)?.type_string)}</span>
          </div>
        </div>
      </div>
      <h5 className={"mt-10 font-weight-bolder"}>{t("label_base_address")}</h5>
      <div className={"mt-8 py-4"}>
        <BaseMapSelector
          latitude={values?.latitude}
          longitude={values?.longitude}
          isSelector={false}
          editable={false}
          zoom={15}
        />
      </div>
      <div className={"d-flex border-bottom py-4"}>
        <div className={"flex-1"}>
          <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
            <span className={"text-neutral-gray"}>{t("label_province")}</span>
            <span className={"font-size-lg"}>{stringFormatting(MasterData?.provinceList?.find((prov) => prov?.id === values?.baseProvince)?.name)}</span>
          </div>
          <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
            <span className={"text-neutral-gray"}>{t("label_city")}</span>
            <span className={"font-size-lg"}>{stringFormatting(MasterData?.regencyList?.find((prov) => prov?.id === values?.baseRegency)?.name)}</span>
          </div>
          <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
            <span className={"text-neutral-gray"}>{t("label_district")}</span>
            <span className={"font-size-lg"}>{stringFormatting(MasterData?.districtList?.find((prov) => prov?.id === values?.baseDistrict)?.name)}</span>
          </div>
        </div>
        <div className={"flex-1"}>
          <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
            <span className={"text-neutral-gray"}>{t("label_subdistrict")}</span>
            <span className={"font-size-lg"}>{stringFormatting(MasterData?.subDistrictList?.find((prov) => prov?.id === values?.baseSubDistrict)?.name)}</span>
          </div>
          <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
            <span className={"text-neutral-gray"}>{t("label_postal_code")}</span>
            <span className={"font-size-lg"}>{stringFormatting(values?.basePostalCode)}</span>
          </div>
          <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
            <span className={"text-neutral-gray"}>{t("label_full_address")}</span>
            <span className={"font-size-lg"}>
              {values?.baseAddress +
                ", " +
                values?.basePostalCode +
                ", " +
                (MasterData?.subDistrictList || []).find((e) => e?.id === values?.baseSubDistrict)
                  ?.name +
                ", " +
                (MasterData?.districtList || []).find((e) => e?.id === values?.baseDistrict)?.name +
                ", " +
                (MasterData?.regencyList || []).find((e) => e?.id === values?.baseRegency)?.name +
                ", " +
                (MasterData?.provinceList || []).find((e) => e?.id === values?.baseProvince)?.name
              }
            </span>
          </div>
        </div>
      </div>
      <h5 className={"mt-10 font-weight-bolder"}>{t("label_assign_base_to_odoo_warehouse")}</h5>
      <div className={"d-flex mt-8 py-4"}>
        <div className={"flex-1"}>
          <div className={"d-flex flex-column mb-5"} style={{ gap: 5 }}>
            <span className={"text-neutral-gray"}>{t("label_odoo_warehouse")}</span>
            <span className={"font-size-lg"}>{values?.useAvaliableWarehouse === "true" ? MasterData?.listWarehouseAvailable?.find((warehouse) => warehouse.id === values?.warehouseId)?.name : t("label_create_new_odoo_warehouse")}</span>
          </div>
        </div>
        <div className={"flex-1"}>
        </div>
      </div>

    </div>
  )
}

